import React from 'react';
import { Stack } from '@mui/material';
import Header from '../components/Header';
import PortfolioContainer from '../components/PortfolioContainer';
import MainContainer from '../components/MainContainer';
const PortfolioPage = () => {

    return (
        <Stack alignItems="center" sx={{flex: 1, height: '100%'}}>
            <Header/>
            <MainContainer>
                <PortfolioContainer/>
            </MainContainer>
        </Stack>
    );
};

export default PortfolioPage;
